import { IQuotationManagementState } from "@/core/interfaces/state/quotationManagmentState.interface";

const quotationManagementState: IQuotationManagementState = {
  groupedQuotesByAirlineMap: null,
  surcharges: [],
  isApplySurchargePending: false,
  isClearAllSurchargesPending: false,
  updatedFareOptions: null,
  quotationRenderTrigger: false,
};

export default quotationManagementState;
